import { render, staticRenderFns } from "./busca-web.vue?vue&type=template&id=2b034fe0&scoped=true&"
import script from "./busca-web.vue?vue&type=script&lang=js&"
export * from "./busca-web.vue?vue&type=script&lang=js&"
import style0 from "./busca-web.vue?vue&type=style&index=0&id=2b034fe0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b034fe0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b034fe0')) {
      api.createRecord('2b034fe0', component.options)
    } else {
      api.reload('2b034fe0', component.options)
    }
    module.hot.accept("./busca-web.vue?vue&type=template&id=2b034fe0&scoped=true&", function () {
      api.rerender('2b034fe0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/busca-web/busca-web.vue"
export default component.exports